import React from "react";
import { Link } from "react-router-dom";
import { LegalNotice } from "@/components/app/LegalNotice";

export function AuthCard({ title, subtitle, children }: { title: string; subtitle?: string; children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-16">
      <div className="rise panel w-full max-w-md p-8">
        <Link to="/login" className="mb-8 block">
          <img src="/img/logo-innova-sign.png" alt="Innova-Sign" className="h-12 w-auto" />
        </Link>
        <h1 data-testid="page-title" className="text-2xl font-semibold tracking-tight text-slate-50">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        <LegalNotice className="mt-8 border-t border-slate-800 pt-6" />
      </div>
    </div>
  );
}
